export default [

     {
          path: '/owner-type',
          name: 'OwnerType',
          component: () => import("@/views/Page/OwnerType/OwnerType.vue"),
           meta: {
               title: '#Default# | OwnerType',
          },
     }
];